import { render, staticRenderFns } from "./VehicleAveragePriceStatistic.vue?vue&type=template&id=57ef57d8&"
import script from "./VehicleAveragePriceStatistic.vue?vue&type=script&lang=js&"
export * from "./VehicleAveragePriceStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports